define('module/upload-form',[
    'jquery',
    'underscore',
    'cnf',
    'util/recaptcha',
    '_pubsub'
], function($, _ , Cnf, Recaptcha, Pubsub) {
    'use strict';
    
    return function()
    {
        var oPubsub=new Pubsub();

        this.options = {
            selector: {
                form: '[data-trigger="upload-form"]',
                submit: 'input [type="submit"], .button-submit',
                msg: '.msg'
            },
            attr:{
                error:'data-error'
            },
            className: {
                disabled: 'disabled'
            }
        }
        this.init = function()
        {
            this.initOptions();
            this.initForm();
        };
        
        this.initOptions = function()
        {
            this.oForm = {};
            this.$form = Cnf.$app.find(this.options.selector.form);
            this.iForm = this.$form.length;
        };

        this.initForm = function()
        {
            if(this.iForm <= 0) {
                return;
            }
            
            var $form;
            for(var i=0; i<this.iForm; i++) {
                $form = this.$form.eq(i);
                $form.on('submit', _.partial(function(_this, index, ev) {
                    ev.preventDefault();
                    if(_this.oForm[index].busy !== false) {
                        return;
                    }

                    //exec recaptcha, trigger submit by deferred
                    Recaptcha.verify().then(_.partial(_this.submit, _this, index, this));
                }, this, i));

                this.oForm[i] = {
                    $form: $form,
                    $input: $form.find(':input'),
                    $submit: $form.find(this.options.selector.submit),
                    $msg: $form.find(this.options.selector.msg),
                    busy:false
                };
            }
        }

        /**
         * callback on submit
         * 
         * @jira FDZ-578
         * @jira FDZ-694
         * @date 2022-09-14
         * @updated 2023-08-23
         * @author sh@sopg.de
         * 
         * @param {object} _this 
         * @param {int} index 
         * @param {object} _thisSubmit 
         * @param {object} recaptcha 
         * @returns 
         */
        this.submit = function(_this, index, _thisSubmit, recaptcha)
        {
            _this.oForm[index].busy = true;
            _this.oForm[index].$submit.addClass('pending');
            _this.oForm[index].$form.addClass(_this.options.className.disabled);
            //trigger delete video
            oPubsub.trigger(Pubsub.DELETE_VIDEO, _this.oForm[index].$msg);
            _this.oForm[index].$msg.html('<div ' + _this.options.attr.error + '="false">&nbsp;</div>');
            
            var formData = new FormData(_thisSubmit);

            //add recaptcha token
            formData.append('recaptcha_token', recaptcha.token);
            formData.append('recaptcha_token_verify', recaptcha.token_verify);

            //add referrer on iframe
            if(window.location !== window.parent.location) {
                formData.append('referrer', document.referrer);
            }

            //assign fn xhr
            var xhr = function(){return $.ajaxSettings.xhr();};
            if(_this.oForm[index].$form.find('progress').length > 0) {
                var $progress = _this.oForm[index].$form.find('progress');
                var $span = $progress.parent().find('span');
                xhr = function() {
                    var xhr = $.ajaxSettings.xhr();
                    if (xhr.upload) {
                        xhr.upload.addEventListener('progress', function (e) {
                            if (e.lengthComputable) {
                                $progress.attr({
                                    value: e.loaded,
                                    max: e.total,
                                });
                                $span.html(((e.loaded / e.total) *100).toFixed(0) + '% (' + (e.loaded / 1024 / 1024).toFixed(0) + 'MB/' + (e.total / 1024 / 1024).toFixed(0) + 'MB)');
                            }
                        }, false);
                    }

                    return xhr;
                }
            }

            //check on complex type
            if(_this.oForm[index].$form.data('type') === 'complex') {
                var iSize = 0;
                
                //A) image
                var $image = _this.oForm[index].$form.find('.upload-form-image-file'),
                    image = $image[0];

                if($image.data('multiple') === true) {
                    //check max count
                    if(image.files.length > $image.data('max')) {
                        _this.oForm[index].busy = false;
                        _this.oForm[index].$submit.removeClass('pending');
                        _this.oForm[index].$form.removeClass(_this.options.className.disabled);
                        _this.oForm[index].$msg.html('<div ' + _this.options.attr.error + '="true">Es sind nur ' + $image.data('max') + ' Bilder erlaubt</div>');
                        return;
                    }

                    for (var i = 0, y = image.files.length; i < y; i++) {
                        formData.append("upload-form-image-file[]", image.files[i]);
                        iSize += image.files[i].size;
                    }
                }
                /**
                 * @see FDZ-491: not sure why to manipulate form object
                 * disabled so far...
                 *  else {
                    for(var i=0, y=$image.length; i<y; i++) {
                        if($image.eq(i)[0].files.length > 0) {
                            formData.append("upload-form-image-file[]", $image.eq(i)[0].files[0]);
                            iSize += $image.eq(i)[0].files[0].size;
                        }

                        //dispose origin
                        formData.delete("upload-form-image-file[" + (i +1) + "]");
                    }
                }
                **/
                
                //check file extension
                if(formData.getAll('upload-form-image-file[]').length > 0) {
                    var aAccept = _.map($image.attr('accept').split(','), function(item) { return item.trim().replace(/\./,''); }),
                        aExtension;

                    for(var imageIndex in formData.getAll('upload-form-image-file[]')) {
                        aExtension = formData.getAll('upload-form-image-file[]')[imageIndex].name.split('.');
                        if(aAccept.indexOf(aExtension[aExtension.length -1].toLowerCase()) < 0) {
                            _this.oForm[index].busy = false;
                            _this.oForm[index].$submit.removeClass('pending');
                            _this.oForm[index].$form.removeClass(_this.options.className.disabled);
                            _this.oForm[index].$msg.html('<div ' + _this.options.attr.error + '="true">Es sind nur folgende Bild-Dateitypen erlaubt: ' + $image.attr('accept') + '</div>');
                            return;
                        }
                    }
                }
                
                //B) video
                var $video = _this.oForm[index].$form.find('#upload-form-video-file'),
                    video = $video[0];
                if(video && video.files && video.files.length > 0) {
                    iSize += video.files[0].size;

                    //check file extension
                    var aAccept = _.map($video.attr('accept').split(','), function(item) { return item.trim().replace(/\./,''); }),
                        aExtension = video.files[0].name.split('.');

                    if(aAccept.indexOf(aExtension[aExtension.length -1].toLowerCase()) < 0) {
                        _this.oForm[index].busy = false;
                        _this.oForm[index].$submit.removeClass('pending');
                        _this.oForm[index].$form.removeClass(_this.options.className.disabled);
                        _this.oForm[index].$msg.html('<div ' + _this.options.attr.error + '="true">Es sind nur folgende Video-Dateitypen erlaubt: ' + $video.attr('accept') + '</div>');
                        return;
                    }
                }

                //check max size
                if(iSize > _this.oForm[index].$form.data('max')) {
                    _this.oForm[index].busy = false;
                    _this.oForm[index].$submit.removeClass('pending');
                    _this.oForm[index].$form.removeClass(_this.options.className.disabled);
                    _this.oForm[index].$msg.html('<div ' + _this.options.attr.error + '="true">Es sind nur insgesamt ' + (_this.oForm[index].$form.data('max') /1024 /1024) + ' MB Dateigröße erlaubt</div>');
                    return;
                }

            }

            //show progress if given
            if($progress) {
                $progress.attr('data-active', 'true');
                $progress.attr({
                    value: 0,
                    max: 100,
                });
                $span.html('0%');
            }

            $.ajax({
                url: window.cnf.host + window.cnf.api,
                dataType: 'json',
                type: 'post',
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                xhr: xhr,
                complete:_.bind(function(index, xhr) {
                    try {
                        //reset form
                        this.oForm[index].busy = false;
                        this.oForm[index].$submit.removeClass('pending');
                        this.oForm[index].$form.removeClass(this.options.className.disabled);
                        this.oForm[index].$msg.html('<div ' + _this.options.attr.error + '="false">&nbsp;</div>');

                        //display success
                        _.each(xhr.responseJSON.success, _.bind(function(msg){
                            var oArg={html:msg};
                            oArg[this.options.attr.error]='false';
                            $('<div/>', oArg).appendTo(this.oForm[index].$msg);
                            
                            //trigger video routine
                            oPubsub.trigger(Pubsub.INIT_VIDEO, this.oForm[index].$msg);
                            if(
                                (typeof window.BorlabsCookie === "object")
                                && (true === window.BorlabsCookie.checkCookieConsent("youtube"))
                            ) {
                                window.BorlabsCookie.unblockContentId("youtube");
                            }
                        },this));
                        
                        //display error
                        _.each(xhr.responseJSON.error, _.bind(function(msg){
                            var oArg={html:msg};
                            oArg[this.options.attr.error]='true';
                            $('<div/>', oArg).appendTo(this.oForm[index].$msg);
                        },this));
                        
                        //renew token if given
                        if(typeof xhr.responseJSON.token!=='undefined') {

                            _.each(xhr.responseJSON.token, _.bind(function(token, name) {
                                this.oForm[index].$input.filter('[name="' + name + '"]').attr('value', token);
                            },this));
                        }

                        //reset on success
                        if(xhr.status === 200) {
                            this.oForm[index].$form.trigger("reset");
                        }
                    } catch(e) {
                        console.log(e, xhr);

                        var entry, mItem, aEntryItem = {};
                        for(entry in formData.entries()) {
                            console.log(entry);
                            mItem = 'nostring';
                            if(typeof entry[1] === 'string') {
                                mItem = entry[1];
                            }

                            aEntryItem[entry[0]] = mItem;
                        }

                        //send log
                        $.ajax({
                            url: window.cnf.host + window.cnf.api,
                            dataType: 'json',
                            type: 'post',
                            data: {
                                action: 'log',
                                error: e,
                                origin: 'upload-form::submit()',
                                items: aEntryItem,
                                xhr: (typeof xhr.responseJSON === 'object' ? xhr.responseJSON : 'unknown'),
                                responseText: xhr.responseText
                            }
                        });
                        this.oForm[index].$form.removeClass(this.options.className.disabled);
                        this.oForm[index].$msg.html('<div ' + this.options.attr.error + '="true">Es ist ein Fehler aufgetreten. Versuchen Sie es zu einem späteren Zeitpunkt erneut.</div>');
                    }
                }, _this, index)
            });

        };

        this.init();
    }
});
